import React from 'react';
import '../../../Context/index.js';
import cx from 'classnames';
import { Link } from 'react-router-dom';
import '../../../../../ui/accordions/Accordion/index.js';
import '../../../../../ui/accordions/AccordionSelect/index.js';
import '../../../../../ui/badges/Badge/index.js';
import '../../../../../ui/badges/BadgeIcon/index.js';
import '../../../../../ui/badges/Checked/index.js';
import '../../../../../ui/badges/Panel/index.js';
import '../../../../../ui/badges/Status/index.js';
import '../../../../../ui/badges/Tag/index.js';
import { BabyButton } from '../../../../../ui/buttons/BabyButton/index.js';
import '../../../../../ui/buttons/Button/index.js';
import '../../../../../ui/buttons/CloseButton/index.js';
import '../../../../../ui/buttons/DirectionButton/index.js';
import '../../../../../ui/buttons/GradientButton/index.js';
import '../../../../../ui/buttons/GradientButtonV2/index.js';
import '../../../../../ui/buttons/TabButton/index.js';
import '../../../../../ui/buttons/TabButtonV2/index.js';
import '../../../../../ui/buttons/TimerButton/index.js';
import '../../../../../ui/buttons/TimerButtonV2/index.js';
import '../../../../../ui/buttons/TimerButtonV3/index.js';
import '../../../../../ui/loaders/Loader/index.js';
import '../../../../../ui/loaders/ScreenLoader/index.js';
import '../../../../../ui/modals/Modal/MobileWrapperV2/index.js';
import '../../../../../ui/modals/Modal/Modal.js';
import '../../../../../ui/modals/Modal/ModalContentWrapper/index.js';
import '../../../../../ui/popups/Popper/index.js';
import '../../../../../ui/popups/Popup/BasePopup/index.js';
import '../../../../../ui/popups/Popup/Thumb/index.js';
import '../../../../../ui/popups/Popup/ThumbV2/index.js';
import '../../../../../ui/popups/Popup/InfoTooltip/index.js';
import '../../../../../ui/sliders/EmblaCarousel/index.js';
import '../../../../../ui/tables/Table/index.js';
import '../../../../../ui/tables/Table/TableTd/index.js';
import '../../../../../ui/tabs/Tabs/index.js';
import '../../../../../ui/tabs/TabsV2/index.js';
import '../../../../../ui/texts/CryptoValue/index.js';
import '../../../../../ui/texts/AmountValue/index.js';
import '../../../../../ui/texts/TitleWithCurrency/index.js';
import '../../../../../ui/texts/Text/index.js';
import '../../../../../ui/texts/TextNavigation/index.js';
import '../../../../../ui/texts/MinValue/index.js';
import '../../../../../ui/socials/SocialsList/index.js';
import desktopLogoImage from './img/logo.svg.js';
import phoneLogoImage from './img/phone_logo_2.svg.js';
import centerGradientImage from './img/gradient_right.png.js';
import styles from './index.module.scss.js';
import { useLayoutContext } from '../../../Context/utils/useLayoutContext.js';

const Header = ({
  className,
  style,
  right,
  rightMdMax,
  center,
  isAuthUser = true,
  routeToHome = "/",
  ...props
}) => {
  const { isAsideMenuOpen, setIsAsideMenuOpen } = useLayoutContext();
  const { responsiveBreakpoints } = useLayoutContext();
  return /* @__PURE__ */ React.createElement("header", { ...props, className: cx(styles.box, className), style }, /* @__PURE__ */ React.createElement(
    "img",
    {
      className: styles.gradient,
      src: centerGradientImage,
      width: 265,
      height: 180,
      "aria-hidden": true,
      alt: ""
    }
  ), /* @__PURE__ */ React.createElement("div", { className: styles.left }, /* @__PURE__ */ React.createElement(
    BabyButton.Menu,
    {
      className: styles["menu-btn"],
      kind: "green",
      title: "Expand Menu",
      onClick: () => setIsAsideMenuOpen(!isAsideMenuOpen),
      "aria-pressed": isAsideMenuOpen
    }
  ), /* @__PURE__ */ React.createElement(Link, { to: routeToHome }, /* @__PURE__ */ React.createElement(
    "img",
    {
      src: desktopLogoImage,
      width: 252,
      height: 32,
      alt: "Logo",
      "aria-hidden": true,
      className: styles["logo-desktop"]
    }
  ), /* @__PURE__ */ React.createElement(
    "img",
    {
      src: isAuthUser ? phoneLogoImage : desktopLogoImage,
      width: 64,
      height: 65,
      alt: "Logo",
      "aria-hidden": true,
      className: cx(styles["logo-mobile"], {
        [styles.isAuthUser]: !isAuthUser
      })
    }
  ))), center && /* @__PURE__ */ React.createElement("div", { className: styles.center }, center), /* @__PURE__ */ React.createElement("div", { className: styles.right }, responsiveBreakpoints.includes("mdMax") ? rightMdMax ?? right : right));
};
Header.displayName = "Layout.Header";

export { Header };
//# sourceMappingURL=index.js.map
